var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMembershipInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C5.14396 0 0 5.14337 0 11.5C0 17.856 5.14337 23 11.5 23C17.856 23 23 17.8566 23 11.5C23 5.14405 17.8566 0 11.5 0ZM12.681 16.065C12.681 16.4283 12.1511 16.7916 11.5002 16.7916C10.819 16.7916 10.3347 16.4283 10.3347 16.065V10.2976C10.3347 9.87378 10.8191 9.5861 11.5002 9.5861C12.1511 9.5861 12.681 9.87378 12.681 10.2976V16.065ZM11.5003 8.19357C10.8039 8.19357 10.259 7.6789 10.259 7.10363C10.259 6.52841 10.804 6.02887 11.5003 6.02887C12.1815 6.02887 12.7265 6.52841 12.7265 7.10363C12.7265 7.6789 12.1814 8.19357 11.5003 8.19357Z",
    fill: "#1F5B8C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipInfoIcon);
export default __webpack_public_path__ + "static/media/membershipInfoIcon.abb4efb886daa2f576e69a0aaeed02b3.svg";
export { ForwardRef as ReactComponent };